import Comment from '@/models/Comment';
import SharedFundCost from '@/models/SharedFundCost';
import SharedFundCostService from '@/services/SharedFundCostService';
import { defineStore } from 'pinia';
import { useRepo } from 'pinia-orm';

export const useSharedFundCostsStore = defineStore('shared_fund_costs', {
  state: () => ({}),

  getters: {
    models: () => useRepo(SharedFundCost),
  },

  actions: {
    async createSharedFundCost(claimId: Id, sharedFundId: Id, request: ApiRequests['api.v1.shared-fund-costs.store']) {
      const [data, error] = await SharedFundCostService.create(claimId, sharedFundId, request);

      if(error) {
        throw error;
      }

      this.models.save(data.cost);

      if(data.comment) {
        useRepo(Comment).save(data.comment);
      }

      return data;
    },

    async updateSharedFundCost(id: Id, request: ApiRequests['api.v1.shared-fund-costs.update']) {
      const [data, error] = await SharedFundCostService.update(id, request);

      if(error) {
        throw error;
      }

      this.models.save(data.cost);

      if(data.comment) {
        useRepo(Comment).save(data.comment);
      }

      return data;
    },

    async updateComment(
      sharedFundCostId: Id,
      commentId: Id,
      request: ApiRequests['api.v1.shared-fund-costs.comments.update'],
    ) {
      const [data, error] = await SharedFundCostService.updateComment(sharedFundCostId, commentId, request);

      if(error) {
        throw error;
      }

      useRepo(Comment).save(data);

      return data;
    },

    async deleteComment(sharedFundCostId: Id, commentId: Id) {
      const [data, error] = await SharedFundCostService.deleteComment(sharedFundCostId, commentId);

      if(error) {
        throw error;
      }

      useRepo(Comment).destroy(data.id);

      return data;
    },

    async deleteSharedFundCost(id: Id) {
      const [data, error] = await SharedFundCostService.delete(id);

      if(error) {
        throw error;
      }

      this.models.destroy(id);

      return data;
    },

    async saveClaim(claimId: Id, signedParams: unknown, request: ApiRequests['api.v1.claims.shared-fund.claim.store']) {
      const [data, error] = await SharedFundCostService.claim(claimId, signedParams, request);

      if(error) {
        throw error;
      }

      this.models.save(data);

      return data;
    },

    async saveCertified(
      claimId: Id,
      signedParams: unknown,
      request: ApiRequests['api.v1.claims.shared-fund.certified.store'],
    ) {
      const [data, error] = await SharedFundCostService.certified(claimId, signedParams, request);

      if(error) {
        throw error;
      }

      this.models.save(data.cost);

      if(data.comment) {
        useRepo(Comment).save(data.comment);
      }

      return data;
    },

    async storeSignedComment(
      claimId: Id,
      signedParams: unknown,
      request: ApiRequests['api.v1.claims.shared-fund-costs.comments.store.signed'],
    ) {
      const [data, error] = await SharedFundCostService.comments.storeSigned(claimId, signedParams, request);

      if(error) {
        throw error;
      }

      useRepo(Comment).save(data);

      return data;
    },

    async updateSignedComment(
      claimId: Id,
      signedParams: unknown,
      request: ApiRequests['api.v1.claims.shared-fund-costs.comments.update.signed'],
    ) {
      const [data, error] = await SharedFundCostService.comments.updateSigned(claimId, signedParams, request);

      if(error) {
        throw error;
      }

      useRepo(Comment).save(data);

      return data;
    },
  },
});
